import { applyMiddleware, compose, createStore } from 'redux'
import { createBrowserHistory } from 'history'
import { createLogger } from 'redux-logger'
import { createReduxHistoryContext } from 'redux-first-history'
import { thunk } from 'redux-thunk'

import { updateIntl } from '../intl/actions'
import { loadState, saveState } from '../localStorage/localStorage'
import createRootReducer from '../reducers'
import enTranslationMessages from '../../translation/en'

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
  history: createBrowserHistory(),
})

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const configureStore = () => {
  const initialState = loadState()

  const middlewares = applyMiddleware(createLogger({ collapsed: true }), routerMiddleware, thunk)

  const store = createStore(createRootReducer(routerReducer), initialState, composeEnhancers(middlewares))

  store.dispatch(updateIntl(enTranslationMessages))

  store.subscribe(() => {
    saveState(store.getState())
  })

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      const nextCreateRootReducer = require('../reducers/index') // eslint-disable-line global-require
      store.replaceReducer(nextCreateRootReducer(routerReducer))
    })
  }

  return store
}

export const store = configureStore()
export const history = createReduxHistory(store)
export default store
